import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "PageSelectedDashboard" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmbeddedDashboard = _resolveComponent("EmbeddedDashboard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "AllDashboardsButton DriverButton",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToOverview && _ctx.goToOverview(...args)))
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "lnr-arrow-left ArrowIcon" }, null, -1 /* CACHED */),
      _createElementVNode("span", null, "Back to All Dashboards", -1 /* CACHED */)
    ]))]),
    _createVNode(_component_EmbeddedDashboard)
  ]))
}